export default "__VITE_ASSET__BUBTRqcc__"